import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import { getContent } from '../../../services';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const StyledSlideShow = styled.div`
  position: relative;
`;

const StyledBanner = styled.img`
  object-fit: contain;
  height: 35vh;
`;

const SlideShow = ({isId}: any) => {
  const [bannerState, setBannerState] = React.useState<any>([]);
  
	const fetchBanner = async () => {
		try {
			const res = await getContent(11, 50, 1);
			setBannerState(res.data.rows);
		} catch (err) {
			console.log(err.message)
		}
	};

	React.useEffect(() => {
		fetchBanner();
	}, []);

  return (
    <StyledSlideShow>
      <Carousel
        autoPlay
        infiniteLoop
        interval={6000}
        showIndicators={true}
        showThumbs={false}
        dynamicHeight
      >
        {bannerState.map((row : any, i: any) => (
          <div key={i} style={{ height: '40vh', position: 'relative' }}>
            <StyledBanner alt={isId ? row.title_id : row.title_en} src={`${process.env.REACT_APP_URL}/images/${isId ? row.content_id: row.content_en}`} />
          </div>
        ))}
      </Carousel>
    </StyledSlideShow>
  );
};

export default SlideShow;
